import { create } from "zustand";

const TTL_MS = 5 * 60 * 1000;

type PosIdentityState = {
  profileId: string | null;
  fullName: string | null;
  expiresAt: number | null;
  setIdentity: (profileId: string, fullName: string | null) => void;
  clear: () => void;
  isValid: () => boolean;
};

export const usePosIdentityStore = create<PosIdentityState>((set, get) => ({
  profileId: null,
  fullName: null,
  expiresAt: null,
  setIdentity: (profileId, fullName) =>
    set({
      profileId,
      fullName,
      expiresAt: Date.now() + TTL_MS,
    }),
  clear: () =>
    set({
      profileId: null,
      fullName: null,
      expiresAt: null,
    }),
  isValid: () => {
    const { expiresAt, profileId } = get();
    return Boolean(profileId && expiresAt && Date.now() < expiresAt);
  },
}));
